import { React,  } from "react";
import loadings from "../../../src/components/Images/loading/gif_loadings.gif";
import { useMyContext } from "../../components/Provider/CommonProvider";
import { connect } from "react-redux";

function Response_Processing({ siteTheme }) {
  const { loadingGifVideo } = useMyContext()
  return (
    <>
      {loadingGifVideo !== null ? (
        <div className="overlay-container">
          <span className="overlay-icon">
            <img src={loadingGifVideo} style={{ width: "80px", height: "80px", objectFit: "contain" }} alt="Animated GIF" />Processing ...
          </span>
        </div>
      ) : (
        <div className="overlay-container">
          <span className="overlay-icon">
            <img src={loadings} style={{ width: "80px", height: "80px", objectFit: "contain" }} alt="Animated GIF" />Processing ...
          </span>
        </div>
      )}
    </>
  );
}

const mapStateToProps = state => ({
  siteTheme: state.siteTheme.data,
});

export default connect(mapStateToProps)(Response_Processing);
